(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var root = document.getElementById('BiogoShipping');
    var standardSource = document.getElementById('BiogoSourceStandard');
    var expressSource = document.getElementById('BiogoSourceExpress');
    var countryInput = document.getElementById('BiogoCountrySearch');
    var countryBox = document.getElementById('BiogoCountryCombobox');
    var optionsRoot = document.getElementById('BiogoCountryOptions');
    var toggleButton = countryBox ? countryBox.querySelector('.biogo-country-combobox__toggle') : null;
    var clearButton = countryBox ? countryBox.querySelector('.biogo-country-combobox__clear') : null;
    var weightInput = document.getElementById('BiogoPackageWeight');
    var submitButton = document.getElementById('BiogoShippingSubmit');
    var status = document.getElementById('BiogoShippingStatus');
    var results = document.getElementById('BiogoShippingResults');

    if (!root || !standardSource || !expressSource || !countryInput || !countryBox || !optionsRoot || !weightInput || !submitButton || !status || !results) {
      return;
    }
var i18nRoot = document.getElementById('BiogoShippingI18n');
var i18n = i18nRoot ? i18nRoot.dataset : {};

function tr(key, fallback) {
  return i18n[key] || fallback;
}

function trReplace(key, fallback, replacements) {
  var text = tr(key, fallback);

  Object.keys(replacements || {}).forEach(function (token) {
    text = text.split(token).join(String(replacements[token]));
  });

  return text;
}
    var aliases = {
      'deutschland': ['germany', 'niemcy', 'allemagne', 'alemania', 'germania', 'de'],
      'osterreich': ['austria', 'autriche', 'at'],
      'frankreich': ['france', 'francja', 'francia', 'fr'],
      'vereinigte staaten': ['usa', 'us', 'united states', 'stany zjednoczone', 'amerika'],
      'vereinigtes konigreich': ['uk', 'united kingdom', 'great britain', 'wielka brytania', 'grossbritannien'],
      'spanien': ['spain', 'hiszpania', 'espagne', 'espana'],
      'italien': ['italy', 'wlochy', 'italie', 'italia'],
      'niederlande': ['netherlands', 'holland', 'holandia', 'pays bas'],
      'belgien': ['belgium', 'belgia', 'belgique'],
      'schweiz': ['switzerland', 'szwajcaria', 'suisse', 'svizzera'],
      'schweden': ['sweden', 'szwecja', 'suede', 'sverige'],
      'norwegen': ['norway', 'norwegia', 'norvege'],
      'danemark': ['denmark', 'dania'],
      'finnland': ['finland', 'finlandia', 'finlande'],
      'tschechien': ['czechia', 'czech republic', 'czechy', 'republique tcheque'],
      'slowakei': ['slovakia', 'slowacja', 'slovaquie'],
      'slowenien': ['slovenia', 'slowenia', 'slovenie'],
      'ungarn': ['hungary', 'wegry', 'hongrie'],
      'rumanien': ['romania', 'rumunia', 'roumanie'],
      'griechenland': ['greece', 'grecja', 'grece'],
      'kroatien': ['croatia', 'chorwacja', 'croatie'],
      'portugal': ['portugalia'],
      'irland': ['ireland', 'irlandia', 'irlande'],
      'japan': ['japonia', 'japon'],
      'kanada': ['canada'],
      'australien': ['australia'],
      'china': ['chiny', 'chine'],
      'indien': ['india', 'indie'],
      'sudkorea': ['south korea', 'korea poludniowa', 'coree du sud'],
      'vereinigte arabische emirate': ['uae', 'are', 'emiraty arabskie']
    };

    var euCountries = new Set([
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT',
      'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
    ]);

    var collator = new Intl.Collator(document.documentElement.lang || 'de', {
      sensitivity: 'base',
      numeric: true
    });
    var currentLocale = document.documentElement.lang || 'de';
var countryNames = null;

try {
  if (typeof Intl.DisplayNames === 'function') {
    countryNames = new Intl.DisplayNames([currentLocale], {
      type: 'region'
    });
  }
} catch (error) {
  countryNames = null;
}

function localizedCountryName(iso, fallback) {
  if (!iso || !countryNames) return fallback;

  try {
    return countryNames.of(iso) || fallback;
  } catch (error) {
    return fallback;
  }
}

    var selectedCountry = null;
    var activeOptionIndex = -1;
    var visibleOptions = [];

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/ł/g, 'l')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function parsePrice(value) {
      var raw = String(value || '').replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
      if (!raw) return Number.POSITIVE_INFINITY;

      var comma = raw.lastIndexOf(',');
      var dot = raw.lastIndexOf('.');
      var decimal = '';

      if (comma !== -1 && dot !== -1) {
        decimal = comma > dot ? ',' : '.';
      } else if (comma !== -1 && raw.length - comma - 1 === 2) {
        decimal = ',';
      } else if (dot !== -1 && raw.length - dot - 1 === 2) {
        decimal = '.';
      }

      if (decimal === ',') {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else if (decimal === '.') {
        raw = raw.replace(/,/g, '');
      } else {
        raw = raw.replace(/[.,]/g, '');
      }

      var number = Number(raw);
      return Number.isFinite(number) ? number : Number.POSITIVE_INFINITY;
    }

    function validPrice(value) {
      var text = normalize(value);
      return Boolean(value) && value !== '—' && value !== '-' && text.indexOf('checkout') === -1;
    }

    function validFreeShipping(value) {
      var text = normalize(value);
      return Boolean(value) && value !== '—' && value !== '-' && text !== 'nein' && text !== 'nicht verfugbar';
    }

    function firstDeliveryDay(value) {
      var match = String(value || '').match(/\d+(?:[.,]\d+)?/);
      return match ? Number(match[0].replace(',', '.')) : Number.POSITIVE_INFINITY;
    }

    function deliveryRange(rows) {
      var numbers = [];
      rows.forEach(function (row) {
        var value = row.cells[2] ? row.cells[2].textContent.trim() : '';
        var matches = value.match(/\d+(?:[.,]\d+)?/g) || [];
        matches.forEach(function (item) {
          var number = Number(item.replace(',', '.'));
          if (Number.isFinite(number)) numbers.push(number);
        });
      });

      if (!numbers.length) return '—';
      var min = Math.min.apply(null, numbers);
      var max = Math.max.apply(null, numbers);
      var workdays = tr('workdays', 'Werktage');

return min === max
  ? min + ' ' + workdays
  : min + '–' + max + ' ' + workdays;
    }

    function levenshtein(a, b) {
      if (a === b) return 0;
      if (!a.length) return b.length;
      if (!b.length) return a.length;

      var previous = new Array(b.length + 1);
      var current = new Array(b.length + 1);
      var i;
      var j;

      for (j = 0; j <= b.length; j += 1) previous[j] = j;

      for (i = 1; i <= a.length; i += 1) {
        current[0] = i;
        for (j = 1; j <= b.length; j += 1) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          current[j] = Math.min(
            current[j - 1] + 1,
            previous[j] + 1,
            previous[j - 1] + cost
          );
        }
        var swap = previous;
        previous = current;
        current = swap;
      }

      return previous[b.length];
    }

    function sourceRows(source) {
      return source.tBodies.length ? Array.from(source.tBodies[0].rows) : [];
    }

    var priorityCountryKeys = [
      'deutschland',
      'frankreich',
      'niederlande',
      'schweden',
      'danemark'
    ];

    function countryPriorityIndex(country) {
      return priorityCountryKeys.indexOf(country.key);
    }

    function buildCountries() {
      var map = new Map();

      [standardSource, expressSource].forEach(function (source) {
        sourceRows(source).forEach(function (row) {
          var visibleName = row.cells[0] ? row.cells[0].textContent.trim() : '';
var sourceName = row.dataset.countryName || visibleName;
var key = normalize(row.dataset.countryKey || sourceName);
var iso = String(row.dataset.iso || '').toUpperCase();
var displayName = localizedCountryName(iso, sourceName);

          if (!map.has(key)) {
            map.set(key, {
  key: key,
  sourceName: sourceName,
  displayName: displayName,
  iso: iso,
              aliases: [],
              rows: [],
              postcodeDependent: false,
              note: ''
            });
          }

          var country = map.get(key);
          country.rows.push(row);
          country.iso = country.iso || iso;
          country.postcodeDependent = country.postcodeDependent || row.dataset.postcodeDependent === 'true';
          country.note = country.note || row.dataset.note || '';
        });
      });

      map.forEach(function (country) {
        country.aliases = (aliases[country.key] || []).map(normalize);
        country.searchValues = [
  country.key,
  normalize(country.sourceName),
  normalize(country.displayName)
].concat(country.aliases);
      });

      return Array.from(map.values()).sort(function (a, b) {
        var priorityA = countryPriorityIndex(a);
        var priorityB = countryPriorityIndex(b);

        if (priorityA !== -1 || priorityB !== -1) {
          if (priorityA === -1) return 1;
          if (priorityB === -1) return -1;
          return priorityA - priorityB;
        }

        return collator.compare(a.displayName, b.displayName);
      });
    }

    var countries = buildCountries();
    var countryByKey = new Map(countries.map(function (country) {
      return [country.key, country];
    }));

    function matchScore(country, rawQuery) {
      var query = normalize(rawQuery);
      if (!query) return 100;

      var best = Number.POSITIVE_INFINITY;
      country.searchValues.forEach(function (value) {
        if (!value) return;
        if (value === query) best = Math.min(best, 0);
        else if (value.indexOf(query) === 0) best = Math.min(best, 10 + value.length - query.length);
        else if (value.indexOf(query) !== -1) best = Math.min(best, 30 + value.indexOf(query));

        if (query.length >= 4) {
          var maxDistance = query.length >= 8 ? 2 : 1;
          var distance = levenshtein(query, value);
          if (distance <= maxDistance) best = Math.min(best, 60 + distance);

          value.split(' ').forEach(function (word) {
            var wordDistance = levenshtein(query, word);
            if (wordDistance <= maxDistance) best = Math.min(best, 65 + wordDistance);
          });
        }
      });

      return best;
    }

    function findCountries(query) {
      return countries
        .map(function (country) {
          return { country: country, score: matchScore(country, query) };
        })
        .filter(function (entry) {
          return Number.isFinite(entry.score);
        })
        .sort(function (a, b) {
          if (a.score !== b.score) return a.score - b.score;
          return collator.compare(a.country.displayName, b.country.displayName);
        })
        .slice(0, 40)
        .map(function (entry) {
          return entry.country;
        });
    }

    function setOpen(isOpen) {
      countryBox.classList.toggle('is-open', isOpen);
      optionsRoot.hidden = !isOpen;
      countryInput.setAttribute('aria-expanded', String(isOpen));
      if (!isOpen) {
        activeOptionIndex = -1;
        countryInput.removeAttribute('aria-activedescendant');
      }
    }

    function updateActiveOption(nextIndex) {
      var buttons = Array.from(optionsRoot.querySelectorAll('.biogo-country-option'));
      if (!buttons.length) return;

      activeOptionIndex = Math.max(0, Math.min(nextIndex, buttons.length - 1));
      buttons.forEach(function (button, index) {
        button.classList.toggle('is-active', index === activeOptionIndex);
      });

      var active = buttons[activeOptionIndex];
      countryInput.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    }

    function renderOptions(query, showAll) {
      visibleOptions = showAll ? countries.slice() : findCountries(query);
      optionsRoot.innerHTML = '';

      if (!visibleOptions.length) {
        var empty = document.createElement('div');
        empty.className = 'biogo-country-options__empty';
        empty.textContent = tr(
  'noCountry',
  'Kein Lieferland gefunden. Bitte prüfen Sie die Schreibweise.'
);
        optionsRoot.appendChild(empty);
        setOpen(true);
        return;
      }

      visibleOptions.forEach(function (country, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'biogo-country-option';
        button.id = 'BiogoCountryOption-' + index;
        button.setAttribute('role', 'option');

        var name = document.createElement('span');
        name.className = 'biogo-country-option__name';
        name.textContent = country.displayName;

        var meta = document.createElement('span');
        meta.className = 'biogo-country-option__meta';
        meta.textContent = country.iso;

        button.appendChild(name);
        button.appendChild(meta);
        button.addEventListener('mousedown', function (event) {
          event.preventDefault();
        });
        button.addEventListener('click', function () {
          selectCountry(country, true);
        });
        optionsRoot.appendChild(button);

        if (showAll && !normalize(query) && index === priorityCountryKeys.length - 1) {
          var divider = document.createElement('div');
          divider.className = 'biogo-country-options__divider';
          divider.setAttribute('aria-hidden', 'true');
          optionsRoot.appendChild(divider);
        }
      });

      activeOptionIndex = -1;
      setOpen(true);
    }

    function selectCountry(country, renderImmediately) {
      selectedCountry = country;
      countryInput.value = country.displayName;
      clearButton.hidden = false;
      setOpen(false);
      status.textContent = trReplace(
  'countrySelected',
  'Lieferland ausgewählt: __COUNTRY__.',
  {
    '__COUNTRY__': country.displayName
  }
);
      if (renderImmediately) renderResults();
    }

    function clearSelection() {
      selectedCountry = null;
      countryInput.value = '';
      clearButton.hidden = true;
      status.textContent = '';
      results.hidden = true;
      results.innerHTML = '';
      renderOptions('', true);
      countryInput.focus();
    }

    function standardColumn(weight) {
      if (weight <= 1) return { index: 4, label: '0–1 kg' };
      if (weight < 3) return { index: 5, label: '1–3 kg' };
      if (weight < 5) return { index: 6, label: '3–5 kg' };
      if (weight < 10) return { index: 7, label: '5–10 kg' };
      if (weight < 20) return { index: 8, label: '10–20 kg' };
      if (weight <= 32) return { index: 9, label: '20–32 kg' };
      return null;
    }

    function expressColumn(weight) {
      if (weight <= 1) return { index: 3, label: '0–1 kg' };
      if (weight < 3) return { index: 4, label: '1–3 kg' };
      if (weight < 5) return { index: 5, label: '3–5 kg' };
      if (weight < 10) return { index: 6, label: '5–10 kg' };
      if (weight < 20) return { index: 7, label: '10–20 kg' };
      if (weight < 30) return { index: 8, label: '20–30 kg' };
      if (weight < 40) return { index: 9, label: '30–40 kg' };
      if (weight < 60) return { index: 10, label: '40–60 kg' };
      return { index: 11, label: '60–70 kg' };
    }

    function countryRows(source, country) {
      return sourceRows(source).filter(function (row) {
        var key = normalize(row.dataset.countryKey || row.dataset.countryName || (row.cells[0] ? row.cells[0].textContent : ''));
        return key === country.key;
      });
    }

    function methodFromRow(row, mode, weight, source) {
      var column = mode === 'standard' ? standardColumn(weight) : expressColumn(weight);

      if (!column) {
        return {
          row: row,
          source: source,
          mode: mode,
          carrier: row.dataset.carrier || (row.cells[1] ? row.cells[1].textContent.trim() : ''),
          delivery: row.cells[2] ? row.cells[2].textContent.trim() : '',
          freeShipping: mode === 'standard' && row.cells[3] ? row.cells[3].textContent.trim() : '',
          price: '',
          priceNumber: Number.POSITIVE_INFINITY,
          bracket: 'über 32 kg'
        };
      }

      var price = row.cells[column.index] ? row.cells[column.index].textContent.trim() : '';
      var orientation = String(row.dataset.orientationPrices || '').split('|');
      var orientationIndex = mode === 'standard' ? column.index - 4 : column.index - 3;

      if (!validPrice(price) && validPrice(orientation[orientationIndex])) {
        price = orientation[orientationIndex];
      }

      return {
        row: row,
        source: source,
        mode: mode,
        carrier: row.dataset.carrier || (row.cells[1] ? row.cells[1].textContent.trim() : ''),
        delivery: row.cells[2] ? row.cells[2].textContent.trim() : '',
        freeShipping: mode === 'standard' && row.cells[3] ? row.cells[3].textContent.trim() : '',
        price: price,
        priceNumber: parsePrice(price),
        bracket: column.label
      };
    }

    function collectMethods(country, weight) {
      var candidates = [];

      countryRows(standardSource, country).forEach(function (row) {
        candidates.push(methodFromRow(row, 'standard', weight, standardSource));
      });

      countryRows(expressSource, country).forEach(function (row) {
        candidates.push(methodFromRow(row, 'express', weight, expressSource));
      });

      var grouped = new Map();
      candidates.forEach(function (method) {
        if (!validPrice(method.price)) return;
        var key = normalize(method.carrier) + '|' + method.mode;
        var current = grouped.get(key);
        if (!current || method.priceNumber < current.priceNumber) grouped.set(key, method);
      });

      return Array.from(grouped.values()).sort(function (a, b) {
        if (a.priceNumber !== b.priceNumber) return a.priceNumber - b.priceNumber;
        var timeDifference = firstDeliveryDay(a.delivery) - firstDeliveryDay(b.delivery);
        if (timeDifference !== 0) return timeDifference;
        return collator.compare(a.carrier, b.carrier);
      });
    }

    function fullPriceRows(method) {
      var row = method.row;
      var source = method.source;
      var startIndex = method.mode === 'standard' ? 4 : 3;
      var list = [];

      for (var index = startIndex; index < row.cells.length; index += 1) {
        var header = source.tHead && source.tHead.rows[0] && source.tHead.rows[0].cells[index]
          ? source.tHead.rows[0].cells[index].textContent.trim().replace(/\s+/g, ' ')
          : '';
        var value = row.cells[index] ? row.cells[index].textContent.trim() : '';
        if (validPrice(value)) list.push({ label: header, value: value });
      }

      return list;
    }

    function renderMethod(method, index) {
      var details = document.createElement('details');
      details.className = 'biogo-method' + (index === 0 ? ' is-cheapest' : '');

      var summary = document.createElement('summary');

      var name = document.createElement('div');
      name.className = 'biogo-method__name';
      name.appendChild(document.createTextNode(method.carrier));
      if (index === 0) {
        var badge = document.createElement('span');
        badge.className = 'biogo-method__badge';
        badge.textContent = tr('cheapest', 'Günstigste Option');
        name.appendChild(badge);
      }
      var type = document.createElement('span');
      type.className = 'biogo-method__type';
      type.textContent = method.mode === 'standard'
  ? tr('standard', 'Standardversand')
  : tr('express', 'Expressversand');
      name.appendChild(type);

      var delivery = document.createElement('span');
      delivery.className = 'biogo-method__delivery';
      delivery.textContent = method.delivery + ' ' + tr('workdays', 'Werktage');

      var bracket = document.createElement('span');
      bracket.className = 'biogo-method__weight';
      bracket.textContent = method.bracket;

      var price = document.createElement('strong');
      price.className = 'biogo-method__price';
      price.textContent =
  tr('from', 'ab') + ' ' + method.price.replace(/^ab\s+/i, '');

      var chevron = document.createElement('span');
      chevron.className = 'biogo-method__chevron';
      chevron.setAttribute('aria-hidden', 'true');

      summary.appendChild(name);
      summary.appendChild(delivery);
      summary.appendChild(bracket);
      summary.appendChild(price);
      summary.appendChild(chevron);
      details.appendChild(summary);

      if (validFreeShipping(method.freeShipping)) {
        var free = document.createElement('div');
        free.className = 'biogo-method__free';
        free.textContent =
  tr('freeShipping', 'Kostenloser Versand') +
  ' ' +
  tr('from', 'ab') +
  ' ' +
  method.freeShipping.replace(/^ab\s+/i, '');
        details.appendChild(free);
      }

      var prices = document.createElement('div');
      prices.className = 'biogo-method__prices';
      fullPriceRows(method).forEach(function (entry) {
        var row = document.createElement('div');
        row.className = 'biogo-method__price-row';
        var label = document.createElement('span');
        label.textContent = entry.label;
        var value = document.createElement('strong');
        value.textContent = entry.value;
        row.appendChild(label);
        row.appendChild(value);
        prices.appendChild(row);
      });
      details.appendChild(prices);

      return details;
    }

    function resolveSelectedCountry() {
      var query = normalize(countryInput.value);
      if (!query) return null;
      if (selectedCountry && (selectedCountry.key === query || normalize(selectedCountry.displayName) === query)) {
        return selectedCountry;
      }

      var exact = countries.find(function (country) {
        return country.searchValues.some(function (value) {
          return value === query;
        });
      });
      if (exact) return exact;

      var matches = findCountries(query);
      return matches.length === 1 ? matches[0] : null;
    }

    function renderResults() {
      var country = resolveSelectedCountry();
      if (!country) {
        status.textContent = tr(
  'selectCountry',
  'Bitte wählen Sie ein Lieferland aus der Liste.'
);
        renderOptions(countryInput.value, false);
        return;
      }

      selectedCountry = country;
      countryInput.value = country.displayName;
      clearButton.hidden = false;
      setOpen(false);

      var weight = Number(String(weightInput.value || '').replace(',', '.'));
      if (!Number.isFinite(weight) || weight <= 0) weight = 0.1;
      if (weight > 70) weight = 70;
      weightInput.value = String(weight);

      var methods = collectMethods(country, weight);
      results.innerHTML = '';
      results.hidden = false;

      var header = document.createElement('div');
      header.className = 'biogo-shipping-results__header';
      var title = document.createElement('h3');
      title.className = 'biogo-shipping-results__title';
      title.textContent = country.displayName;
      var summary = document.createElement('span');
      summary.className = 'biogo-shipping-results__summary';
      summary.textContent =
  methods.length +
  ' ' +
  (methods.length === 1
    ? tr('oneMethod', 'Versandart')
    : tr('manyMethods', 'Versandarten')) +
  ' · ' +
  tr('cheapestFirst', 'günstigste zuerst');
      header.appendChild(title);
      header.appendChild(summary);
      results.appendChild(header);

      if (country.postcodeDependent) {
        var postcode = document.createElement('p');
        postcode.className = 'biogo-shipping-results__postcode';
        postcode.textContent =
  country.note ||
  tr(
    'postcodeNote',
    'Verfügbarkeit und Preis können je nach Postleitzahl abweichen. Die endgültigen Optionen werden im Checkout angezeigt.'
  );
        results.appendChild(postcode);
      }

      if (country.iso && !euCountries.has(country.iso)) {
        var customs = document.createElement('p');
        customs.className = 'biogo-shipping-results__customs';
        customs.textContent = tr(
  'customsNote',
  'Je nach Lieferland können zusätzliche Einfuhrabgaben, Zölle oder Steuern anfallen.'
);
        results.appendChild(customs);
      }

      var list = document.createElement('div');
      list.className = 'biogo-method-list';

      if (!methods.length) {
        var empty = document.createElement('p');
        empty.className = 'biogo-shipping-results__postcode';
        empty.textContent = tr(
  'noMethods',
  'Für dieses Gewicht wurden keine Orientierungspreise gefunden. Bitte prüfen Sie die verfügbaren Optionen im Checkout.'
);
        list.appendChild(empty);
      } else {
        methods.forEach(function (method, index) {
          list.appendChild(renderMethod(method, index));
        });
      }

      results.appendChild(list);
      status.textContent = trReplace(
  'pricesFor',
  'Preise für __COUNTRY__ und __WEIGHT__ kg.',
  {
    '__COUNTRY__': country.displayName,
    '__WEIGHT__': weight
  }
);
    }

    function bestPrice(rows, cellIndex) {
      var candidates = rows.map(function (row) {
        return row.cells[cellIndex] ? row.cells[cellIndex].textContent.trim() : '';
      }).filter(validPrice);

      if (!candidates.length) return '—';
      candidates.sort(function (a, b) {
        return parsePrice(a) - parsePrice(b);
      });
      return tr('from', 'ab') + ' ' + candidates[0].replace(/^ab\s+/i, '');
    }

    function bestFreeShipping(rows) {
      var values = rows.map(function (row) {
        return row.cells[3] ? row.cells[3].textContent.trim() : '';
      }).filter(validFreeShipping);
      if (!values.length) return '—';
      values.sort(function (a, b) {
        return parsePrice(a) - parsePrice(b);
      });
      return tr('from', 'ab') + ' ' + values[0].replace(/^ab\s+/i, '');
    }

    function groupRows(source, filterFn) {
      var map = new Map();
      sourceRows(source).forEach(function (row) {
        if (filterFn && !filterFn(row)) return;
        var key = normalize(row.dataset.countryKey || row.dataset.countryName || (row.cells[0] ? row.cells[0].textContent : ''));
        var country = countryByKey.get(key);
        if (!country) return;
        if (!map.has(key)) map.set(key, { country: country, rows: [] });
        map.get(key).rows.push(row);
      });
      return Array.from(map.values()).sort(function (a, b) {
        return collator.compare(a.country.displayName, b.country.displayName);
      });
    }

    function buildCompareTable(source, targetId, mode, filterFn) {
      var target = document.getElementById(targetId);
      if (!target || !source.tHead) return;

      var sourceHeaders = Array.from(source.tHead.rows[0].cells).map(function (cell) {
        return cell.textContent.trim().replace(/\s+/g, ' ');
      });
      var priceStart = mode === 'standard' ? 4 : 3;

      var table = document.createElement('table');
      table.className = 'biogo-compare-table biogo-compare-table--' + mode;
      var thead = document.createElement('thead');
      var headRow = document.createElement('tr');

      var headers = [
  tr('tableCountry', 'Land'),
  tr('tableDelivery', 'Zustellzeit ab Versand')
];

if (mode === 'standard') {
  headers.push(
    tr('tableFree', 'Kostenloser Versand')
  );
}

headers = headers.concat(sourceHeaders.slice(priceStart));

      headers.forEach(function (header) {
        var th = document.createElement('th');
        th.textContent = header;
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      var tbody = document.createElement('tbody');
      groupRows(source, filterFn).forEach(function (group) {
        var tr = document.createElement('tr');
        var countryCell = document.createElement('td');
        countryCell.textContent = group.country.displayName;
        if (group.country.postcodeDependent) {
          var note = document.createElement('span');
          note.className = 'biogo-compare-table__country-note';
          note.textContent = tr(
  'postcodeTableNote',
  'Preis kann je nach Postleitzahl abweichen.'
);
          countryCell.appendChild(note);
        }
        tr.appendChild(countryCell);

        var deliveryCell = document.createElement('td');
        deliveryCell.textContent = deliveryRange(group.rows);
        tr.appendChild(deliveryCell);

        if (mode === 'standard') {
          var freeCell = document.createElement('td');
          freeCell.textContent = bestFreeShipping(group.rows);
          tr.appendChild(freeCell);
        }

        for (var index = priceStart; index < sourceHeaders.length; index += 1) {
          var priceCell = document.createElement('td');
          priceCell.textContent = bestPrice(group.rows, index);
          tr.appendChild(priceCell);
        }

        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      target.innerHTML = '';
      target.appendChild(table);

      var accordion = target.closest('.biogo-table-accordion');
      var topScroll = accordion ? accordion.querySelector('.biogo-table-top-scroll') : null;
      var topInner = topScroll ? topScroll.querySelector('.biogo-table-top-scroll__inner') : null;
      var topThumb = null;

      if (topScroll && topInner) {
        topScroll.setAttribute('role', 'scrollbar');
        topScroll.setAttribute(
  'aria-label',
  tr('tableScroll', 'Tabelle horizontal scrollen')
);
        topScroll.setAttribute('aria-orientation', 'horizontal');
        topScroll.setAttribute('tabindex', '0');
        topInner.innerHTML = '';
        topThumb = document.createElement('span');
        topThumb.className = 'biogo-table-top-scroll__thumb';
        topInner.appendChild(topThumb);
      }

      function tableMaxScroll() {
        return Math.max(0, target.scrollWidth - target.clientWidth);
      }

      function updateTopScrollbar() {
        if (!topScroll || !topInner || !topThumb) return;
        var maxScroll = tableMaxScroll();
        var trackWidth = topInner.clientWidth;
        var visibleRatio = table.scrollWidth > 0 ? target.clientWidth / table.scrollWidth : 1;
        var thumbWidth = maxScroll > 0 ? Math.max(48, Math.round(trackWidth * visibleRatio)) : trackWidth;
        thumbWidth = Math.min(trackWidth, thumbWidth);
        var maxThumbLeft = Math.max(0, trackWidth - thumbWidth);
        var thumbLeft = maxScroll > 0 ? Math.round((target.scrollLeft / maxScroll) * maxThumbLeft) : 0;

        topThumb.style.width = thumbWidth + 'px';
        topThumb.style.transform = 'translateX(' + thumbLeft + 'px)';
        topScroll.classList.toggle('is-disabled', maxScroll <= 0);
        topScroll.setAttribute('aria-valuemin', '0');
        topScroll.setAttribute('aria-valuemax', String(Math.round(maxScroll)));
        topScroll.setAttribute('aria-valuenow', String(Math.round(target.scrollLeft)));
      }

      function setTableScrollFromTrack(clientX, preserveGrabOffset) {
        if (!topInner || !topThumb) return;
        var maxScroll = tableMaxScroll();
        if (maxScroll <= 0) return;
        var rect = topInner.getBoundingClientRect();
        var thumbWidth = topThumb.getBoundingClientRect().width;
        var maxThumbLeft = Math.max(1, rect.width - thumbWidth);
        var grabOffset = preserveGrabOffset || thumbWidth / 2;
        var thumbLeft = Math.min(maxThumbLeft, Math.max(0, clientX - rect.left - grabOffset));
        target.scrollLeft = (thumbLeft / maxThumbLeft) * maxScroll;
      }

      if (topScroll && topInner && topThumb) {
        var dragging = false;
        var dragOffset = 0;

        topScroll.addEventListener('pointerdown', function (event) {
          if (topScroll.classList.contains('is-disabled')) return;
          var thumbRect = topThumb.getBoundingClientRect();
          dragging = true;
          dragOffset = event.target === topThumb
            ? Math.min(thumbRect.width, Math.max(0, event.clientX - thumbRect.left))
            : thumbRect.width / 2;
          topScroll.classList.add('is-dragging');
          topScroll.setPointerCapture(event.pointerId);
          setTableScrollFromTrack(event.clientX, dragOffset);
          event.preventDefault();
        });

        topScroll.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          setTableScrollFromTrack(event.clientX, dragOffset);
          event.preventDefault();
        });

        function stopDragging(event) {
          if (!dragging) return;
          dragging = false;
          topScroll.classList.remove('is-dragging');
          if (event && topScroll.hasPointerCapture(event.pointerId)) {
            topScroll.releasePointerCapture(event.pointerId);
          }
        }

        topScroll.addEventListener('pointerup', stopDragging);
        topScroll.addEventListener('pointercancel', stopDragging);

        topScroll.addEventListener('keydown', function (event) {
          var step = Math.max(80, target.clientWidth * 0.25);
          if (event.key === 'ArrowRight') target.scrollLeft += step;
          else if (event.key === 'ArrowLeft') target.scrollLeft -= step;
          else if (event.key === 'PageDown') target.scrollLeft += target.clientWidth * 0.8;
          else if (event.key === 'PageUp') target.scrollLeft -= target.clientWidth * 0.8;
          else if (event.key === 'Home') target.scrollLeft = 0;
          else if (event.key === 'End') target.scrollLeft = tableMaxScroll();
          else return;
          event.preventDefault();
        });

        topScroll.addEventListener('wheel', function (event) {
          if (tableMaxScroll() <= 0) return;
          var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          target.scrollLeft += delta;
          event.preventDefault();
        }, { passive: false });
      }

      target.addEventListener('scroll', updateTopScrollbar, { passive: true });

      if (accordion) {
        accordion.addEventListener('toggle', function () {
          if (accordion.open) window.setTimeout(updateTopScrollbar, 40);
        });
      }
      window.addEventListener('resize', updateTopScrollbar);
      updateTopScrollbar();
    }

    buildCompareTable(standardSource, 'BiogoEuropeStandardTable', 'standard', null);
    buildCompareTable(expressSource, 'BiogoEuropeExpressTable', 'express', function (row) {
      return row.dataset.region === 'europe';
    });
    buildCompareTable(expressSource, 'BiogoWorldExpressTable', 'express', function (row) {
      return row.dataset.region !== 'europe';
    });

    document.querySelectorAll('.biogo-table-accordion').forEach(function (details) {
      var closeButton = details.querySelector('.biogo-table-close button');
      var summary = details.querySelector(':scope > summary');
      if (!closeButton || !summary) return;
      closeButton.addEventListener('click', function () {
        details.open = false;
        summary.focus({ preventScroll: true });
        summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    countryInput.addEventListener('focus', function () {
      renderOptions(countryInput.value, !normalize(countryInput.value));
    });

    countryInput.addEventListener('input', function () {
      selectedCountry = null;
      clearButton.hidden = !countryInput.value;
      renderOptions(countryInput.value, !normalize(countryInput.value));
    });

    countryInput.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (optionsRoot.hidden) renderOptions(countryInput.value, !normalize(countryInput.value));
        updateActiveOption(activeOptionIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (optionsRoot.hidden) renderOptions(countryInput.value, !normalize(countryInput.value));
        updateActiveOption(activeOptionIndex <= 0 ? visibleOptions.length - 1 : activeOptionIndex - 1);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (!optionsRoot.hidden && activeOptionIndex >= 0 && visibleOptions[activeOptionIndex]) {
          selectCountry(visibleOptions[activeOptionIndex], true);
        } else {
          renderResults();
        }
      } else if (event.key === 'Escape') {
        setOpen(false);
      }
    });

    toggleButton.addEventListener('click', function () {
      if (optionsRoot.hidden) {
        renderOptions('', true);
        countryInput.focus();
      } else {
        setOpen(false);
      }
    });

    clearButton.addEventListener('click', clearSelection);
    submitButton.addEventListener('click', renderResults);

    weightInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        renderResults();
      }
    });

    weightInput.addEventListener('change', function () {
      if (selectedCountry) renderResults();
    });

    document.addEventListener('click', function (event) {
      if (!countryBox.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openTable = document.querySelector('.biogo-table-accordion[open]');
      if (!openTable) return;
      var summary = openTable.querySelector(':scope > summary');
      openTable.open = false;
      if (summary) summary.focus();
    });
  });
})();
